/* tslint:disable */
/* eslint-disable */
/**
 * Opus API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatus } from './MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatus';
import {
    MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusFromJSON,
    MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusFromJSONTyped,
    MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusToJSON,
} from './MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatus';

/**
 * 
 * @export
 * @interface MondayStatusChangeProjectMilestoneRequestPayloadInputFields
 */
export interface MondayStatusChangeProjectMilestoneRequestPayloadInputFields {
    /**
     * 
     * @type {string}
     * @memberof MondayStatusChangeProjectMilestoneRequestPayloadInputFields
     */
    bidNumberColumn: string;
    /**
     * 
     * @type {number}
     * @memberof MondayStatusChangeProjectMilestoneRequestPayloadInputFields
     */
    boardId: number;
    /**
     * 
     * @type {number}
     * @memberof MondayStatusChangeProjectMilestoneRequestPayloadInputFields
     */
    itemId: number;
    /**
     * 
     * @type {MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatus}
     * @memberof MondayStatusChangeProjectMilestoneRequestPayloadInputFields
     */
    status: MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatus;
}

/**
 * Check if a given object implements the MondayStatusChangeProjectMilestoneRequestPayloadInputFields interface.
 */
export function instanceOfMondayStatusChangeProjectMilestoneRequestPayloadInputFields(value: object): value is MondayStatusChangeProjectMilestoneRequestPayloadInputFields {
    if (!('bidNumberColumn' in value) || value['bidNumberColumn'] === undefined) return false;
    if (!('boardId' in value) || value['boardId'] === undefined) return false;
    if (!('itemId' in value) || value['itemId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsFromJSON(json: any): MondayStatusChangeProjectMilestoneRequestPayloadInputFields {
    return MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsFromJSONTyped(json, false);
}

export function MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MondayStatusChangeProjectMilestoneRequestPayloadInputFields {
    if (json == null) {
        return json;
    }
    return {
        
        'bidNumberColumn': json['bidNumberColumn'],
        'boardId': json['boardId'],
        'itemId': json['itemId'],
        'status': MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusFromJSON(json['status']),
    };
}

export function MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsToJSON(value?: MondayStatusChangeProjectMilestoneRequestPayloadInputFields | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'bidNumberColumn': value['bidNumberColumn'],
        'boardId': value['boardId'],
        'itemId': value['itemId'],
        'status': MondayStatusChangeProjectMilestoneRequestPayloadInputFieldsStatusToJSON(value['status']),
    };
}

